/**
 * ebilling 連携が有効かどうかを表すフィーチャーフラグ。
 *
 * ebilling をセットアップしない環境では VITE_EBILLING_DISABLED に 'true' を設定して
 * 請求書送付先など ebilling 由来の UI（メニュー・ページ）を非表示にする。
 *
 * これは「意図的に ebilling を無効化する」フラグであり、未設定（または 'true' 以外）のデフォルトは有効。
 */
export const isEbillingEnabled =
  import.meta.env.VITE_EBILLING_DISABLED !== 'true'

/**
 * 新基盤(M2M)APIキー機能が有効かどうかを表すフィーチャーフラグ。
 *
 * 開発中の機能のため、VITE_M2M_API_KEYS_ENABLED に 'true' を設定した環境でのみ
 * APIキー関連の UI(メニュー・ページ)を表示する。
 */
export const isApiKeysEnabled =
  import.meta.env.VITE_M2M_API_KEYS_ENABLED === 'true'
